import { setDoc } from 'firebase/firestore'
import { aiPlanRef } from './hooks'

// Sends a natural-language edit request against the user's existing AI plan
// (see netlify/functions/adjust-plan.js) and writes the sanitized result
// back over it. Only workouts/weeklyPattern/menus are touched -
// targetKcal/targetProtein/generatedAt are left as they were.
export async function adjustAiPlan(uid, aiPlan, message, profile) {
  const res = await fetch('/api/adjust-plan', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      message,
      profile,
      currentPlan: {
        workouts: aiPlan.workouts,
        weeklyPattern: aiPlan.weeklyPattern,
        menus: aiPlan.menus,
      },
    }),
  })

  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.error || 'Plan adjustment failed')
  }

  const { workouts, weeklyPattern, menus, summary } = await res.json()
  await setDoc(aiPlanRef(uid), { workouts, weeklyPattern, menus, updatedAt: new Date().toISOString() }, { merge: true })
  return summary
}
